var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "id": "bigdata",
            "title": "솔루션",
            "src": "/images/sub/subvisual-solution.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "page-section--first",
    scopedSlots: _vm._u([{
      key: "titleLine",
      fn: function fn() {
        return [_vm._v(" AI 빅데이터 ")];
      },
      proxy: true
    }])
  }, [_c('tit-wrap-large', {
    staticClass: "mb-0",
    scopedSlots: _vm._u([{
      key: "text",
      fn: function fn() {
        return [_c('b', [_vm._v("근권부 빅데이터")]), _vm._v("는 농업에서 혁신적인 아이디어와 솔루션을 제공하는 이레아이에스만의 차별점 입니다. ")];
      },
      proxy: true
    }])
  }, [_c('b', [_vm._v("AI 빅데이터 농업")]), _vm._v(" "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v("보다 쉽고 체계적인 미래농업으로 인도합니다. ")])], 1), _c('page-section', {
    staticClass: "d-flex align-center min-h-lg-980px"
  }, [_c('div', {
    staticClass: "page-section__bg",
    staticStyle: {
      "background-image": "url(/images/sub/solution/bigdata/bigdata-bg.jpg)"
    }
  }), _c('div', {
    attrs: {
      "data-aos": "fade",
      "data-aos-delay": "100"
    }
  }, [_c('v-divider', {
    staticStyle: {
      "border-color": "rgba(255,255,255,0.2)"
    }
  }), _c('div', {
    staticClass: "py-20px py-md-40px py-xl-80px text-center"
  }, [_c('div', {
    staticClass: "tit-wrap tit-wrap--sm white--text"
  }, [_c('h4', {
    staticClass: "tit tit--lg"
  }, [_vm._v("지속가능한 미래농업을 제안하는 AI 빅데이터")])]), _c('div', {
    staticClass: "txt txt--xl white--text"
  }, [_vm._v("이레아이에스는 매일 농가로부터 2억여 건의 데이터를 수집하고 분석하여 작물생산환경에 최적화된 농업 레시피를 제공합니다. "), _c('br', {
    staticClass: "d-none d-lg-block"
  }), _vm._v("인구증가, 기후변화, 물 부족 등으로 다가올 미래 식량위기를 데이터 기반 농업으로 해결할 수 있는 방법을 제안합니다.")])]), _c('v-divider', {
    staticStyle: {
      "border-color": "rgba(255,255,255,0.2)"
    }
  })], 1)]), _c('page-section-image', {
    attrs: {
      "imageSrc": "/images/sub/solution/bigdata/bigdata-img.jpg",
      "reverse": ""
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "tit tit--lg letter-spacing-n04"
        }, [_vm._v("보다 더 쉬운 농업의 방식을 제시하는 근권부 AI 빅데이터 솔루션")])];
      },
      proxy: true
    }, {
      key: "text",
      fn: function fn() {
        return [_vm._v(" 작물의 근권부(뿌리주변)의 정보는 농업에서 우위를 차지하는 차별화된 데이터입니다. 재배환경의 문제를 실시간으로 진단하고 농업인에게 데이터를 기반한 작물의 상태 인지 및 솔루션에 대한 의사결정 대시보드를 제공함으로써 농업 변수의 예측과 대처가 가능해집니다. ")];
      },
      proxy: true
    }])
  }), _c('page-section-image', {
    staticClass: "page-section--last",
    attrs: {
      "imageSrc": "/images/sub/solution/bigdata/bigdata-img2.jpg"
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "tit tit--lg"
        }, [_vm._v("편리하고 정확한 데이터 기반 "), _c('br', {
          staticClass: "d-none d-lg-block"
        }), _vm._v("스마트팜 운영")])];
      },
      proxy: true
    }, {
      key: "text",
      fn: function fn() {
        return [_vm._v(" 10여년간 축적한 근권부 데이터를 활용해 작물의 생장과 생육상태를 모니터링하여 작물의 성장을 최적화 하고 수확량을 높여줍니다. 데이터 농업은 농민을 더 스마트하게 농사를 지을 수 있도록 도와줍니다. ")];
      },
      proxy: true
    }])
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }